"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../material/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _empty_styles = _interopRequireDefault(require("./empty_styles"));

var _empty_definition = _interopRequireDefault(require("./empty_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : STATE : EMPTY ~~~~~~~~~~ ========== */


var EmptyState = (0, _reactJss.default)(_empty_styles.default)(function (props) {
  return _react.default.createElement("div", {
    className: "state emptystate ".concat(props.classes.emptystate, " ").concat(props.klass)
  }, _react.default.createElement(_index.Illustration, {
    name: props.graphicName,
    text: props.graphicText
  }), _react.default.createElement(_index.Copy, null, _react.default.createElement(_index.BodyCopy, null, _react.default.createElement("p", null, props.bodycopy))), _react.default.createElement(_index.CTAs, null, !!props.buttonClick ? _react.default.createElement(_index.Button, {
    type: "custom",
    handleClick: props.buttonClick,
    variant: "primary",
    name: props.buttonName,
    text: props.buttonText
  }) : null));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(EmptyState, _empty_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = EmptyState;
exports.default = _default;